if (!customElements.get('lisa-thermal-picker')) {
  customElements.define('lisa-thermal-picker', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      const data = this.querySelector('[data-thermal-variants]');
      const strings = document.getElementById('LisaThermalStrings');
      const native = this.querySelector('[data-thermal-native]');
      const selects = [...native?.querySelectorAll('select') || []];
      if (!data || !strings || selects.length !== 2) return;
      const variants = JSON.parse(data.textContent);
      const labels = JSON.parse(strings.textContent);
      const colorsText = JSON.parse(document.getElementById('LisaBeanieStrings').textContent).colors;
      const match = (size, color) => variants.find(v => v.options[0] === size && v.options[1] === color);
      const selected = () => variants.find(v => selects.every((s, i) => v.options[i] === s.value));
      const normalized = value => String(value || '').trim().toLocaleLowerCase();
      const colorOf = v => ['Black', 'Gray', 'White'].find(key =>
        [key, colorsText[key]].some(value => value && normalized(value) === normalized(v.options[1]))
      )?.toLowerCase() || 'assorted';
      const sizeIsAssorted = v => ['Assorted', labels.assorted].some(value => normalized(value) === normalized(v.options[0]));
      const make = (tag, className, text) => {
        const el = document.createElement(tag);
        if (className) el.className = className;
        if (text) el.textContent = text;
        return el;
      };
      const id = selects[0].id || `thermal-${Math.random().toString(36).slice(2)}`;
      const sizes = make('fieldset', 'lisa-beanie__colors');
      sizes.append(make('legend', 'form__label', labels.size));
      const sizeButtons = make('div', 'lisa-pom__pills');
      const sizeControls = [];
      for (const size of [...new Set(variants.map(v => v.options[0]))]) {
        const sample = variants.find(v => v.options[0] === size);
        const label = make('label', 'lisa-pom__pill');
        const input = make('input');
        input.type = 'radio'; input.name = `${id}-size`; input.value = size;
        label.append(input, make('span', '', sizeIsAssorted(sample) ? labels.assorted : size));
        sizeButtons.append(label); sizeControls.push(input);
      }
      sizes.append(sizeButtons);
      const colors = make('fieldset', 'lisa-beanie__colors');
      const currentColor = make('strong');
      const legend = make('legend', 'form__label');
      legend.append(document.createTextNode(`${labels.color}: `), currentColor);
      colors.append(legend);
      const swatches = make('div', 'lisa-beanie__swatches');
      const colorControls = [];
      const palette = {black:'#191919', gray:'#858587', white:'#f7f4ee'};
      for (const color of [...new Set(variants.map(v => v.options[1]))]) {
        const sample = variants.find(v => v.options[1] === color);
        const key = colorOf(sample);
        const title = key === 'assorted' ? labels.assorted : colorsText[key[0].toUpperCase() + key.slice(1)] || color;
        const label = make('label', 'lisa-beanie__swatch');
        label.title = title;
        const input = make('input');
        input.type = 'radio'; input.name = `${id}-color`; input.value = color;
        const chip = make('span', 'lisa-beanie__chip');
        chip.style.setProperty('--swatch', palette[key] || '#888');
        if (key === 'assorted') chip.style.background = 'linear-gradient(135deg,#191919 0 33%,#858587 33% 66%,#f7f4ee 66%)';
        chip.setAttribute('aria-hidden', 'true');
        label.append(input, chip, make('span', key === 'assorted' ? 'lisa-thermal__assorted-label' : 'visually-hidden', title));
        swatches.append(label); colorControls.push({input,title});
      }
      colors.append(swatches);
      colors.hidden = colorControls.length === 1;
      this.append(sizes, colors);
      if (!this.querySelector('lisa-thermal-offer')) {
        const group = this.querySelector('variant-selects')?.dataset.url?.includes('/men-thermal-underwear') ? 'Men' : 'Women';
        const template = document.getElementById(`LisaThermal${group}Offer`);
        if (template) this.prepend(template.content.cloneNode(true));
      }
      native.hidden = true;
      this.ready = true;
      const choose = variant => {
        if (!variant) return;
        selects.forEach((s,i) => {s.value = variant.options[i];});
        selects[0].dispatchEvent(new Event('change',{bubbles:true}));
      };
      const sync = () => {
        const v = selected();
        if (!v) return;
        for (const input of sizeControls) {
          input.checked = input.value === v.options[0];
          input.disabled = !match(input.value,v.options[1])?.available;
        }
        for (const c of colorControls) {
          c.input.checked = c.input.value === v.options[1];
          c.input.disabled = !match(v.options[0],c.input.value)?.available;
          if (c.input.checked) currentColor.textContent = c.title;
        }
      };
      sizes.addEventListener('change', e => {const v=selected();choose(match(e.target.value,v.options[1]));});
      colors.addEventListener('change', e => {const v=selected();choose(match(v.options[0],e.target.value));});
      selects.forEach(s => s.addEventListener('change',sync));
      const normalize = () => {
        const current = selected();
        const single = current && match(current.options[0], current.options[1]);
        if (single) choose(single);
        sync();
      };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', normalize, {once:true});
      else normalize();
      window.LisaSales?.watch(this,sync);
    }
  });
}


